export function paginate(current: number, max: number, isMobile: boolean) {
  if (!current || !max) return []

  let items = [1]

  if (current === 1 && max === 1) return items

  // 0 meaning the ellipsis (…)
  if (current > (isMobile ? 3 : 4)) items.push(0)

  // Adjust the range based on isMobile
  const r = isMobile ? 1 : 2 // Number of pages to show on each side of the current page
  const r1 = current - r
  const r2 = current + r

  for (let i = r1 > 2 ? r1 : 2; i <= Math.min(max, r2); i++) items.push(i)

  // If the last page is bigger than r2 by 2, it must have “…” on the right side.
  if (r2 + 1 < max) items.push(0)
  if (r2 < max) items.push(max)

  return items
}
